import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sorting-arrow",
  "use": "sorting-arrow-usage",
  "viewBox": "0 0 19 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 16\" id=\"sorting-arrow\">\n<title>sorting-arrow</title>\n<path d=\"M7.030 3.949c1.029-1.764 3.578-1.764 4.607 0l4.691 8.041c1.037 1.778-0.245 4.010-2.303 4.010h-9.381c-2.058 0-3.34-2.233-2.303-4.010l4.691-8.041z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol